module.exports = __webpack_public_path__ + "assets/img/seaside.6533d9ef.jpg";